const eventsUserSettingsNames = {
	profileClick: 'user_settings-profile-click',
	contentClick: 'user_settings-content-click',
	securityClick: 'user_settings-security-click',
	closeClick: 'user_settings-close-click',
	profileSaveClick: 'user_settings_profile-save_click',
	profileBackClick: 'user_settings_profile-back_click',
	contentSaveClick: 'user_settings_content-save_click',
	contentBackClick: 'user_settings_content-back_click',
	securitySaveClick: 'user_settings_security-save_click',
	securityBackClick: 'user_settings_security-back_click',
};

export default eventsUserSettingsNames;
